import React from 'react'
import { PITCHES, NUMERALS, MAJOR_NUMERALS_PRESET, MAJOR_EXTRA_NUMERALS_PRESET } from './editorConstants'
import { getPitchJSX } from './editorUtils'
import './PitchSelect.css'

export default function PitchSelect(props)
{
    const {pitch, handlePitchChange} = props; 
    const blackKeys = Object.keys(MAJOR_EXTRA_NUMERALS_PRESET).map(numeral => PITCHES[NUMERALS.indexOf(numeral)]);
    const blackIntervals = [64, 18, 146, 18, 18];
    const whiteKeys = Object.keys(MAJOR_NUMERALS_PRESET).map(numeral => PITCHES[NUMERALS.indexOf(numeral)]);
    
    return (
        <div className='pitch-select'>
            <div className='black-keys'>
                {blackKeys.map((value, index) => <div key={index} style={{marginLeft: blackIntervals[index]}} className={pitch === value ? 'pitch-slot selected' :'pitch-slot'} onClick={() => handlePitchChange(value)}>{getPitchJSX(value)}</div>)}
            </div>
            <div className='white-keys'>
                {whiteKeys.map((value, index) => <div key={index} className={pitch === value ? 'pitch-slot selected' :'pitch-slot'} onClick={() => handlePitchChange(value)}>{getPitchJSX(value)}</div>)}
            </div>
        </div>
    );
}